import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '../..';

export const getI18nLoadedStateSelector = createSelector(
  (state: RootState) => state.i18n,
  (state) => state.loaded,
);

export const i18nSelectors = {
  i18nLoaded: getI18nLoadedStateSelector,
};
